import { styled, Theme, Box, ListItem } from '@mui/material';

export const SubMenuContainer = styled(Box)(({ theme }: {theme: Theme}) => ({
  position: 'absolute',
  left: '100%',
  top: '-8px',
  backgroundColor: '#1D3461',
  borderRadius: '0 4px 4px 0',
  boxShadow: theme.shadows[3],
  zIndex: 1200,
  width: 'max-content',
  padding: '8px 0',
  opacity: 0,
  visibility: 'hidden',
  transform: 'translateX(-10px)',
  transition: 'all 0.3s ease',
}));

export const SubMenuItem = styled(ListItem)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  padding: '12px 16px',
  color: theme.palette.common.white,
  gap: '8px',
  cursor: disabled ? 'default' : 'pointer',
  justifyContent: 'space-between',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: disabled ? 'transparent' : '#16448f',
  },
}));